import { NOTICE_HS_STAFF } from "../../apiConstant";
import BaseApi from "api/baseApi";

class HSNotice extends BaseApi {
  createPost(body: {
    id?: number;
    title?: string;
    content?: string;
    reply_to?: string;
    is_important?: boolean;
    mentions?: [];
    is_deleted?: boolean;
  }) {
    return this.post(NOTICE_HS_STAFF, body);
  }

  getPostList(body: {
    per?: number;
    page?: number;
    search?: string;
    notify_tab?: number;
    notification_category_id?: number;
    start_at?: string;
    end_at?: string;
  }) {
    return this.get(NOTICE_HS_STAFF, body);
  }

  createNotification(body: {
    patient_id: number;
    deployment_date: string;
    content: string;
  }) {
    return this.post(NOTICE_HS_STAFF, body);
  }

  createNotificationGroup(body: {
    notification_category_id: number;
    content: string;
  }) {
    return this.post(`${NOTICE_HS_STAFF}/group`, body);
  }

  getPostDetail(postId: number) {
    return this.get(`${NOTICE_HS_STAFF}/${postId}`);
  }

  getByParent(reply_to: number) {
    return this.get(`${NOTICE_HS_STAFF}/${reply_to}/replies_by_parent`);
  }

  getServiceDetail(id: any) {
    return this.get(`${NOTICE_HS_STAFF}/${id}`);
  }

  updatePost(body: {
    id?: number;
    title?: string;
    content?: string;
    reply_to?: string;
    is_important?: boolean;
    mentions?: [];
    is_deleted?: boolean;
  }) {
    return this.put(`${NOTICE_HS_STAFF}/${body?.id}`, body);
  }
}

export default HSNotice;
